import { render, staticRenderFns } from "./ImgView.vue?vue&type=template&id=db617176&scoped=true&"
import script from "./ImgView.vue?vue&type=script&lang=js&"
export * from "./ImgView.vue?vue&type=script&lang=js&"
import style0 from "./ImgView.vue?vue&type=style&index=0&id=db617176&prod&scoped=true&lang=css&"
import style1 from "./ImgView.vue?vue&type=style&index=1&id=db617176&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db617176",
  null
  
)

export default component.exports